import { useEffect } from "react";
import { queryPayComplete } from "../../api/order";
import { useNavigate } from "react-router";

const AllInPay = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  /**
   * 通联回跳后主动触发一次交易完成，再进入结果页展示状态
   */
  const complete = async () => {
    const transactionId =
      queryParams.get("cusorderid") || queryParams.get("reqsn");
    if (!transactionId) return;
    try {
      await queryPayComplete({ transaction_id: transactionId });
    } finally {
      navigate("/result?transaction_id=" + transactionId);
    }
  };

  useEffect(() => {
    complete();
  }, []);
  return <div></div>;
};

export default AllInPay;
